import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { mapCoordsToYCoords } from '../../utils';

/** Наш формат опций геообъекта */

export var YPoint = /*#__PURE__*/function () {
  function YPoint(options) {
    _classCallCheck(this, YPoint);
    _defineProperty(this, "options", void 0);
    this.options = options;
  }

  /** Возвращает объект настроек геообъекта в формате яндекса */
  return _createClass(YPoint, [{
    key: "getOptions",
    value: function getOptions() {
      var _this$options = this.options,
        coordinates = _this$options.coordinates,
        id = _this$options.id,
        name = _this$options.name;
      var options = this.getInternalOptions();
      var yCoordinates = mapCoordsToYCoords(coordinates);
      return {
        id: id,
        geometry: {
          coordinates: yCoordinates,
          type: 'Point'
        },
        type: 'Feature',
        properties: {
          name: name,
          options: this.options
        },
        options: _objectSpread({}, options)
      };
    }

    /** Возвращает поле опций для объекта настроек геообъекта в формате яндекса */
  }, {
    key: "getInternalOptions",
    value: function getInternalOptions() {
      var _this$options2 = this.options,
        width = _this$options2.width,
        height = _this$options2.height,
        iconLayout = _this$options2.component,
        _this$options2$zIndex = _this$options2.zIndex,
        zIndex = _this$options2$zIndex === void 0 ? 750 : _this$options2$zIndex,
        _this$options2$xOffse = _this$options2.xOffset,
        xOffset = _this$options2$xOffse === void 0 ? -width / 2 : _this$options2$xOffse,
        _this$options2$yOffse = _this$options2.yOffset,
        yOffset = _this$options2$yOffse === void 0 ? -height : _this$options2$yOffse;
      return {
        iconLayout: iconLayout,
        iconOffset: [xOffset, yOffset],
        iconSize: [width, height],
        iconColor: '#2b87db',
        iconShape: this.getIconShape(),
        zIndex: zIndex
      };
    }
  }, {
    key: "getIconShape",
    value: function getIconShape() {
      var _this$options3 = this.options,
        geometry = _this$options3.geometry,
        width = _this$options3.width,
        height = _this$options3.height;
      if (geometry === 'Rectangle') {
        return {
          type: 'Rectangle',
          coordinates: [[0, 0], [width, height]]
        };
      }
      return {
        type: 'Circle',
        coordinates: [width / 2, height / 2],
        radius: Math.max(width, height) / 2
      };
    }
  }]);
}();